import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "react-apollo";
import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";

const httpLink = new HttpLink({
  //uri: "https://api.graph.cool/simple/v1/cjc9c9l594sdl01896m2k439x"
  uri: "https://api.graph.cool/simple/v1/cj6ciegfq1ywj0121xva6iegc"
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache()
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,

  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js